// src/components/ComboBarLineChart.js
import React from "react";
import { Chart as ChartJS, BarElement, LineElement, CategoryScale, LinearScale, PointElement, Title, Tooltip, Legend } from "chart.js";
import { Chart } from "react-chartjs-2";

// Registrar componentes necesarios
ChartJS.register(
  BarElement,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

// Colores base
const CHART_COLORS = {
  red: "rgb(255, 99, 132)",
  blue: "rgb(54, 162, 235)",
};

// Función para hacer colores transparentes
const transparentize = (color, opacity = 0.5) =>
  color.replace("rgb", "rgba").replace(")", `, ${opacity})`);

// Etiquetas y datos
const labels = ["January", "February", "March", "April", "May", "June", "July"];

const data = {
  labels,
  datasets: [
    {
      label: "Dataset 1 (Bar)",
      data: [65, 59, 80, 81, 56, 55, 40],
      backgroundColor: transparentize(CHART_COLORS.red, 0.5),
      borderColor: CHART_COLORS.red,
      type: "bar",
      order: 1,
    },
    {
      label: "Dataset 2 (Line)",
      data: [28, 48, 40, 19, 86, 27, 90],
      backgroundColor: transparentize(CHART_COLORS.blue, 0.5),
      borderColor: CHART_COLORS.blue,
      type: "line",
      order: 0,
    },
  ],
};

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Chart.js Combined Line/Bar Chart",
    },
  },
};

const Chart6 = () => {
  return <Chart type="bar" data={data} options={options} />;
};

export default Chart6;
